import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Legal() {
  return (
    <div id="main-content" className="max-w-3xl mx-auto px-4 py-12" data-testid="legal-page">
      <Link to="/" className="btn-ghost mb-4 inline-flex items-center gap-1">
        <ArrowLeft size={16} weight="bold" /> Retour à l’accueil
      </Link>
      <h1 className="font-display font-black text-4xl tracking-tight mb-8">Mentions légales</h1>

      <section className="space-y-6 text-sm leading-relaxed text-zinc-700">
        <div>
          <h2 className="font-display font-extrabold text-lg text-black mb-2">Éditeur du site</h2>
          <p>
            <strong>Easy Pièces</strong> est édité par <strong>IDMATOI</strong><br />
            Adresse de contact : 9 rue Attoumani Oili, 97600 KOUNGOU<br />
            SIRET : <span className="mono">99538926900011</span><br />
            Téléphone : <a href="tel:+262639628588" className="underline">06 39 62 85 88</a><br />
            Email : <a href="mailto:contact@easypieces.fr" className="underline">contact@easypieces.fr</a>
          </p>
        </div>

        <div>
          <h2 className="font-display font-extrabold text-lg mb-2">Demande de pièce et devis</h2>
          <p>
            Décrivez votre besoin en pièce pour poids lourd ou engin de chantier. Easy Pièces recherche
            auprès de ses fournisseurs, prépare un devis puis vous le transmet. L’envoi du formulaire
            constitue une demande de devis, sans engagement de commande.
          </p>
          <Link to="/#demande-pl-tp" className="inline-block mt-3 underline">Faire une demande ou nous contacter</Link>
        </div>

        <div>
          <h2 className="font-display font-extrabold text-lg text-black mb-2">Propriété intellectuelle</h2>
          <p>
            L'ensemble des éléments accessibles sur le site (textes, images, marques, logos) sont protégés.
            Les marques et logos des équipementiers et constructeurs cités appartiennent à leurs propriétaires respectifs.
          </p>
        </div>

        <div>
          <h2 className="font-display font-extrabold text-lg text-black mb-2">Données personnelles (RGPD)</h2>
          <p>
            Les coordonnées et les informations sur votre véhicule, votre engin et la pièce recherchée
            servent à traiter votre demande, rechercher une solution auprès des fournisseurs,
            préparer et vous transmettre un devis, puis assurer le suivi de vos échanges.
            Les informations des comptes et commandes existants servent également au suivi de la relation
            commerciale avec Easy Pièces. Vous disposez d’un droit d’accès, de rectification et
            de suppression sur vos données. Pour exercer ce droit, contactez-nous à{" "}
            <a href="mailto:contact@easypieces.fr" className="underline">contact@easypieces.fr</a>.
          </p>
        </div>

        <div>
          <h2 className="font-display font-extrabold text-lg text-black mb-2">Prix, disponibilité et livraison</h2>
          <p>
            Les visuels illustrent les familles de pièces. Ils ne constituent pas une confirmation de
            disponibilité ou de compatibilité. Les conditions de prix, de règlement et de livraison
            sont précisées lors de la préparation du devis, selon la pièce et la destination demandées.
          </p>
        </div>

        <div>
          <h2 className="font-display font-extrabold text-lg text-black mb-2">Nous contacter</h2>
          <p>
            Pour une question sur votre demande ou votre devis, appelez le{" "}
            <a href="tel:+262639628588" className="underline">06 39 62 85 88</a>{" "}
            ou écrivez à <a href="mailto:contact@easypieces.fr" className="underline">contact@easypieces.fr</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
